<template>
    <FloatingPanel>
        <div class="vacancy::canvas-blocks-custom-parallaxSlider-BlockPanel">
            <div slot="Algemeen">
                <CommonInputs :options="options" />
            </div>
        </div>
    </FloatingPanel>
</template>

<script>
import AbstractPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel';
import FloatingPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel';
import CommonInputs from '@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs';

export default {
    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
    },
};
</script>
